var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDept(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1736693674045,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2675,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M894.32 644.64l-116.74 99.84a96 96 0 0 0-21.32 26l-26.72 47.74c-1.38 2.46-2.64 4.94-3.78 7.5l-161.22-10.62 9.46-132.28a96.16 96.16 0 0 1 28.26-54.14l33.08-31.8L728 520c17.88-14.82 45.04-12.68 59.5 5.48a41.42 41.42 0 0 1-6 57.68L741.84 616a13.58 13.58 0 0 0 7.72 24 48.18 48.18 0 0 0 29.34-9.46L810 604.88a48 48 0 0 0 17.34-36.66l0.66-183.48a42 42 0 0 1 41.42-41.74c23.54-0.3 42.66 19.8 42.52 43.34l-0.88 222.1a48 48 0 0 1-16.74 36.2z",
    fill: "#F9BF87",
    "p-id": 2676
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M540.78 883m0-10.18l0-72.48q0-10.18 10.18-10.18l203.52 0q10.18 0 10.18 10.18l0 72.48q0 10.18-10.18 10.18l-203.52 0q-10.18 0-10.18-10.18Z",
    fill: "#686F77",
    "p-id": 2677
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M704.9 836.58a18.64 18.64 0 1 0 37.28 0 18.64 18.64 0 1 0-37.28 0Z",
    fill: "#868E96",
    "p-id": 2678
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M769.3 526.88a28.7 28.7 0 1 1-39.22 10.4 28.72 28.72 0 0 1 39.22-10.4z",
    fill: "#FFF4E6",
    "p-id": 2679
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M129.68 644.64l116.74 99.84a96 96 0 0 1 21.32 26l26.72 47.74c1.38 2.46 2.64 4.94 3.78 7.5l161.22-10.62-9.46-132.28a96.16 96.16 0 0 0-28.26-54.14l-33.08-31.8L296 520c-17.88-14.82-45.04-12.68-59.5 5.48a41.42 41.42 0 0 0 6 57.68L282.16 616a13.58 13.58 0 0 1-7.72 24 48.18 48.18 0 0 1-29.34-9.46L214 604.88a48 48 0 0 1-17.34-36.66L196 384.74a42 42 0 0 0-41.48-41.74c-23.54-0.3-42.66 19.8-42.52 43.34l0.88 222.1a48 48 0 0 0 16.8 36.2z",
    fill: "#F9BF87",
    "p-id": 2680
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M259.34 883m0-10.18l0-72.48q0-10.18 10.18-10.18l203.52 0q10.18 0 10.18 10.18l0 72.48q0 10.18-10.18 10.18l-203.52 0q-10.18 0-10.18-10.18Z",
    fill: "#686F77",
    "p-id": 2681
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M281.82 836.58a18.64 18.64 0 1 0 37.28 0 18.64 18.64 0 1 0-37.28 0Z",
    fill: "#868E96",
    "p-id": 2682
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M254.7 526.88a28.7 28.7 0 1 0 39.22 10.4 28.72 28.72 0 0 0-39.22-10.4z",
    fill: "#FFF4E6",
    "p-id": 2683
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M512.84 545.9l-0.14-288.76 0.14 288.76z",
    fill: "#FFCC90",
    opacity: 0.5,
    "p-id": 2684
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M239.5 257.14l-0.02 0.04 273.36 288.72-124.76-288.76h-148.58z",
    fill: "#845EF7",
    "p-id": 2685
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M308.8 141h-0.12l-69.18 116.14h148.58L308.8 141z",
    fill: "#B197FC",
    "p-id": 2686
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M512.42 141H308.8l79.28 116.14 124.34-116.14z",
    fill: "#9775FA",
    "p-id": 2687
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M512 545.9l0.14-288.76-0.14 288.76z",
    fill: "#FFCC90",
    opacity: 0.5,
    "p-id": 2688
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M785.34 257.14l0.02 0.04L512 545.9l124.76-288.76h148.58z",
    fill: "#845EF7",
    "p-id": 2689
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M716.04 141h0.12l69.18 116.14h-148.58l79.28-116.14z",
    fill: "#B197FC",
    "p-id": 2690
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M512.64 141.2v-0.2h-0.44v0.2l-124.12 115.94h248.68L512.64 141.2z",
    fill: "#845EF7",
    "p-id": 2691
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M512.42 141h203.62l-79.28 116.14-124.34-116.14zM636.76 257.14H388.08L512 543.82v2.08l0.42-1.04 0.42 1.04v-2.08l123.92-286.68z",
    fill: "#9775FA",
    "p-id": 2692
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDept);
export default __webpack_public_path__ + "static/media/dept.60b9edb6ac054ba5edd858cb24a35fad.svg";
export { ForwardRef as ReactComponent };